import React from 'react'
import { FilterComponent } from '../../components/_WMS/FilterComponent/FilterComponent'
import { Filter } from '../../components/_WMS/FilterComponent'
import { filterOptions } from './config'

interface WorkOrderRecallSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  onAddButtonClick?: () => void
  addButtonTitle?: string
  createButtonTooltip?: string
}

export const WorkOrderRecallSearch: React.FC<WorkOrderRecallSearchProps> = ({
  onSearchClick,
  selectedFilters,
  setSelectedFilters,
  onAddButtonClick,
  addButtonTitle,
  createButtonTooltip
}) => {
  return (
    <FilterComponent
      options={filterOptions}
      onSearchClick={onSearchClick}
      selectedFilters={selectedFilters}
      setSelectedFilters={setSelectedFilters}
      includeSearchOnClean={true}
      onAddButtonClick={onAddButtonClick}
      addButtonTitle={addButtonTitle}
      createButtonTooltip={createButtonTooltip}
    />
  )
}
